<div class="h-full w-full flex flex-col flex-1 space-y-3">
	<div class="leading-none text-left font-semibold">
		{{ controller.baseI18n + '.title' | translate }}
	</div>
	<ng-container *ngFor="let diploma of diplomasArray.controls; let i = index">
		<spr-coach-settings-general-diploma-header
			class="space-y-1"
		></spr-coach-settings-general-diploma-header>
		<spr-coach-settings-general-diploma-diploma
			[form]="diploma"
			class="flex flex-col items-stretch space-y-3"
		>
			<button
				[disabled]="!diploma.valid"
				(click)="onRemoveDiplomaClick(i)"
				class="p-button-outlined border-none text-blue-900 text-lg"
				icon="fak fa-str-trash"
				pButton
			></button>
		</spr-coach-settings-general-diploma-diploma>
	</ng-container>
	<ng-container>
		<spr-coach-settings-general-diploma-header></spr-coach-settings-general-diploma-header>
		<spr-coach-settings-general-diploma-diploma
			[form]="newDiploma"
			class="flex flex-col items-stretch space-y-3"
		>
			<button
				[disabled]="!newDiploma.valid"
				(click)="onAddDiplomaClick()"
				class="p-button-outlined border-none text-blue-900 text-lg leading-none"
				icon="fas fa-plus"
				pButton
			></button>
		</spr-coach-settings-general-diploma-diploma>
	</ng-container>
</div>
